let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5JnGw")).then(() => parcelRequire('kzp7K'));